import type { CentreData } from './types';

export const penrithData: CentreData = {
  slug: 'penrith',
  name: 'Schoolola Penrith',
  suburb: 'Penrith',
  region: 'Western Sydney',
  state: 'NSW',
  stateName: 'New South Wales',
  status: 'operational',
  yearLevels: 'Kindergarten - Year 8',
  canonicalPath: '/centres/penrith/',
  heroImage: 'https://schoolola.com.au/centres/penrith-og.jpg',
  address: {
    street: '78 Derby Street',
    city: 'Penrith',
    postcode: '2750',
    lat: -33.7506,
    lng: 150.6936,
  },
  contact: {
    phone: '(02) 8552 9339',
    phoneHref: '+61285529339',
    email: 'penrith@schoololatutoring.com.au',
  },
  heroSubtitle:
    'A new Schoolola centre is opening in Penrith. OC, selective school and NAPLAN preparation by qualified NSW Curriculum teachers using the proven TMRW™ methodology.',
  trustStrip: [
    { k: 'In-person', v: '78 Derby Street' },
    { k: 'Kindergarten - Year 8', v: 'All primary year levels' },
    { k: 'NSW Curriculum', v: 'Qualified teachers' },
  ],
  breadcrumb: { regionLabel: 'Western Sydney' },
  googleRating: {
    value: 5.0,
    count: 5,
    profileUrl: 'https://www.google.com/search?q=Schoolola+Tutoring+Penrith',
  },
  reviews: [
    {
      author: 'Inma Conde',
      rating: 5,
      timeAgo: 'a month ago',
      datePublished: '2026-04-29',
      body: 'Highly recommended',
    },
    {
      author: 'rohit thakur',
      rating: 5,
      timeAgo: 'a month ago',
      datePublished: '2026-04-29',
      isLocalGuide: true,
      body: "Highly recommend Schoolola Tutoring in Penrith! The tutors are extremely professional, patient, and genuinely committed to helping students succeed. They take the time to understand each student's learning style and provide personalised support.",
    },
    {
      author: 'Siddharth Sharma',
      rating: 5,
      timeAgo: 'a month ago',
      datePublished: '2026-04-29',
      body: 'Amazing experience for my kids, well done and keep it up 👍',
    },
    {
      author: 'Deepak K',
      rating: 5,
      timeAgo: 'a month ago',
      datePublished: '2026-04-29',
      body: '',
    },
    {
      author: 'Ramesh Shekar',
      rating: 5,
      timeAgo: 'a month ago',
      datePublished: '2026-04-29',
      body: '',
    },
  ],
  suburbsServed: ['Penrith', 'Kingswood', 'Caddens', 'Werrington'],
  programs: [
    {
      id: 'oc',
      title: 'OC TMRW™ Preparation',
      yearPill: { label: 'Yr 3 - 4', tone: 'info' },
      tagline: 'Comprehensive OC exam preparation with proven TMRW™ strategies',
      bullets: ['Thinking Skills', 'Mathematical Reasoning', 'Reading'],
      educationalLevel: 'Year 3 to Year 4',
      description: 'Comprehensive OC exam preparation for primary students using the proven TMRW™ methodology, with practice tests and structured strategy training.',
      featured: 'popular',
    },
    {
      id: 'selective',
      title: 'Selective TMRW™ Preparation',
      yearPill: { label: 'Yr 5 - 6', tone: 'info' },
      tagline: 'Expert coaching for selective school entrance examinations',
      bullets: ['Thinking Skills', 'Mathematical Reasoning', 'Reading', 'Writing'],
      educationalLevel: 'Year 5 to Year 6',
      description: 'Expert coaching for selective school entrance examinations, specialised for primary students using the TMRW™ methodology.',
    },
    {
      id: 'foundations',
      title: 'Foundations Course',
      yearPill: { label: 'K - Year 8', tone: 'success' },
      tagline: 'Core English and maths · all primary year levels',
      bullets: ['Phonics, fluency, comprehension', 'Number sense to fractions', 'Writing structure across genres'],
      educationalLevel: 'Kindergarten to Year 8',
      description: 'Core English and mathematics tutoring for Kindergarten through Year 8 students, aligned to the NSW Curriculum.',
    },
    {
      id: 'naplan',
      title: 'NAPLAN Preparation',
      yearPill: { label: 'Yr 3, 5', tone: 'info' },
      tagline: '10-week term aligned to ACARA',
      bullets: ['Reading and writing', 'Numeracy strategies', 'Language conventions'],
      educationalLevel: 'Year 3 and Year 5',
      description: '10-week term NAPLAN preparation course covering reading, writing, language conventions and numeracy, aligned to ACARA test specifications.',
    },
  ],
  differentiators: [
    {
      title: 'NSW Curriculum specialists',
      body: "Lessons map to what your child's school actually teaches, not generic worksheets.",
      icon: 'BookOpen',
    },
    {
      title: 'Measurable progress reports',
      body: 'Regular assessments tracked against ACARA bands.',
      icon: 'LineChart',
    },
    {
      title: 'Small group ratios',
      body: 'Small group sizes for genuine individual attention while keeping the energy of peer learning.',
      icon: 'Users',
    },
    {
      title: 'OC and Selective track record',
      body: 'Network students placed at Penrith High, Blacktown Boys, Girraween High and other Western Sydney selective schools.',
      icon: 'Trophy',
    },
  ],
  faqs: [
    {
      question: 'When will the Penrith centre open?',
      answer: 'We are working on establishing our Penrith centre to serve Penrith, Kingswood, Caddens and Werrington. Contact us at penrith@schoololatutoring.com.au for updates on opening dates and early registration.',
    },
    {
      question: 'What year levels will Schoolola Penrith tutor?',
      answer: 'Kindergarten through Year 8. Foundations covers all primary year levels in English and maths; OC, Selective and NAPLAN programmes target specific testing years.',
    },
    {
      question: 'Which programmes will be offered?',
      answer: 'OC TMRW™ Preparation, Selective TMRW™ Preparation, NAPLAN Preparation and our Foundations Course - all aligned to the NSW Curriculum.',
    },
    {
      question: 'How can I register interest before opening?',
      answer: 'Email penrith@schoololatutoring.com.au and we will add you to the Penrith list. You will be the first to hear about opening dates, enrolments and assessments.',
    },
    {
      question: 'Do you offer online tutoring in the meantime?',
      answer: 'Yes. Online tutoring is available through our existing NSW centres while the Penrith centre is being established.',
    },
  ],
};
